<!--报表 销售退库单 详情-->
<template>
  <div id="stockdetail">
    <el-row>
      <el-col :span="12">
        <ul>
          <li>客户名称：{{ titleData.TC_NAME }}</li>
          <li>项&nbsp;&nbsp;&nbsp;&nbsp;目&nbsp;&nbsp;&nbsp;&nbsp;点：{{ titleData.PROJECT_NAME }}</li>
          <li>档口：{{ titleData.DK_NAME }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>订单编号：{{ titleData.ORDER_CODE }}</li>
          <li>退库日期：{{ titleData.RETURN_DAY }}</li>
          <li>入库总金额：{{ totalFee }}</li>
          <li>退库总金额：{{ realFee }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="退库数量"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="销售价"></el-table-column>
          <el-table-column prop="REAL_FEE" label="退库金额"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="入库价"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="入库金额"></el-table-column>
          <el-table-column prop="RETURN_REASON" label="退库理由"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button @click="toPrintTable">打印退库单</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { returnWareFun } from 'api/returnWare';
import { print } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      titleData: {},
      totalFee: '',
      realFee: '',
      projectFee: '',
      companyName: '',
      statusFlag: 0,
      checkData: [],
    };
  },
  created() {
    this.companyName = sessionStorage.getItem('company');
    this.getRecordDetail();
  },
  methods: {
    // ----------------------拉取数据
    getRecordDetail() {
      this.titleData = JSON.parse(sessionStorage.getItem('returnMess'));
      const params = {
        RETURN_ORDER_ID: Number(sessionStorage.getItem('RETURN_ID')),
      };
      returnWareFun(params)
        .then((result) => {
          if (result.DATA && result.DATA.length > 0) {
            this.tableData = result.DATA;
            this.totalFee = result.DATA.reduce((totalPrice, item) => totalPrice + Number(item.PRODUCT_FEE), 0);
            this.realFee = result.DATA.reduce((realPrice, item) => realPrice + Number(item.REAL_FEE), 0);
            this.projectFee = result.DATA.reduce((pPrice, item) => pPrice + Number(item.PROJECT_FEE), 0);
            this.checkData = result.OR[0] ? result.OR[0].DATA : [];
            this.statusFlag = result.OR[0] ? result.OR[0].RN : 0;
          } else {
            this.tableData = [];
            this.totalFee = 0;
            this.realFee = 0;
            this.projectFee = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title">${this.companyName}销售退库单</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">项目点：${this.titleData.PROJECT_NAME}</div><div style="font-size: 20px;">档口：${this.titleData.DK_NAME}</div><div style="font-size: 20px;">日期：${this.titleData.RETURN_DAY}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">盘库单编号：${this.titleData.ORDER_CODE}</div><div style="font-size: 20px;">总金额：${this.projectFee}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th>产品</th> <th>单位</th> <th  style="width: 40px">单价</th> <th style="width: 70px">退库数量</th> <th  style="width: 70px">退库金额</th> <th>退货理由</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.PRODUCT_NAME}</td>  <td>${item.TYPE_UNIT}</td> <td>${item.REAL_PRICE}</td>
                 <td>${item.PRODUCT_COUNT}</td> <td>${item.REAL_FEE}</td> <td>${item.RETURN_REASON}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += '<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div>退货人：</div><div style="margin-left: 200px; font-size: 20px;">主管：</div></div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/returnWareDetail.vue